import Image from '@ui/image'
import {
  BoxLargeImgWrap,
  BoxLargeImgInner,
  BoxLargeImgMedia,
  BoxLargeImgContent,
  HeadingWrap,
  CategoryWrap,
  TextWrap,
  BoxCircleBtnWrap,
  BoxCircleBtnInner,
  BoxCircleBtn
} from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'

const BoxLargeImage = ({
  image,
  title,
  category,
  desc,
  path,
  className,
  layout,
  ...restProps
}) => {
  return (
    <BoxLargeImgWrap to={path} className={className} {...restProps}>
      <BoxLargeImgInner>
        {image?.src && (
          <BoxLargeImgMedia>
            <Image
              src={image.src.localFile || image.src}
              alt={image.src.alternativeText || title}
              sizes="(min-width: 768px) 500px, 100vw"
            />
          </BoxLargeImgMedia>
        )}
        <BoxLargeImgContent $layout={layout}>
          {title && (
            <HeadingWrap as="h5" $layout={layout}>
              {title}
            </HeadingWrap>
          )}
          {category && <CategoryWrap>{category}</CategoryWrap>}
          {desc && <TextWrap $layout={layout}>{desc}</TextWrap>}
          {path && (
            <BoxCircleBtnWrap>
              <BoxCircleBtnInner>
                <div className="middle-dot" />
                <div className="middle-dot dot-2" />
                <BoxCircleBtn>
                  <FontAwesomeIcon icon={faArrowRight} />
                </BoxCircleBtn>
              </BoxCircleBtnInner>
            </BoxCircleBtnWrap>
          )}
        </BoxLargeImgContent>
      </BoxLargeImgInner>
    </BoxLargeImgWrap>
  )
}

export default BoxLargeImage
